import { useNotificationStore, type NotificationEventType } from '../stores/notification-store';

const NOTIFICATION_CONFIG: Record<NotificationEventType, { title: string; body: string }> = {
  gameStart: { title: 'UNO - Game starts', body: 'The game has begun, come and play your cards!' },
  myTurn: { title: 'UNO - now you', body: "Now it's your turn to play your cards!" },
  gameEnd: { title: 'UNO - game over', body: 'This game has ended, check the results!' },
  kicked: { title: 'UNO - removed from room', body: 'You have been removed from the room' },
  roomDissolved: { title: 'UNO - Room disbanded', body: 'The room you are in has been dismissed' },
};

export function sendNotification(type: NotificationEventType, overrideBody?: string): void {
  if (typeof Notification === 'undefined') return;
  if (Notification.permission !== 'granted') return;
  if (!document.hidden) return;

  const { preferences } = useNotificationStore.getState();
  if (!preferences[type]) return;

  const config = NOTIFICATION_CONFIG[type];
  new Notification(config.title, {
    body: overrideBody ?? config.body,
    icon: '/favicon.svg',
  });
}
